import { render, staticRenderFns } from "./quicklyResult.vue?vue&type=template&id=90a6359a&scoped=true&"
import script from "./quicklyResult.vue?vue&type=script&lang=js&"
export * from "./quicklyResult.vue?vue&type=script&lang=js&"
import style0 from "./quicklyResult.vue?vue&type=style&index=0&id=90a6359a&lang=less&scoped=true&"
import style1 from "./quicklyResult.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a6359a",
  null
  
)

export default component.exports